var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "right-content" },
    [
      _c("InformationUp", { ref: "informationUp" }),
      _c("AiAssistantDrawer", { ref: "AiAssistantDrawer" }),
      _vm.showGuideBtn
        ? _c(
            "a",
            {
              staticClass: "right-content__action right-content__action--btn",
              on: { click: _vm.SCMGuild },
            },
            [
              _c("icon-font", {
                staticStyle: { "margin-right": "5px", color: "inherit" },
                attrs: { type: "gb-icon-zidingyiguanlix" },
              }),
              _vm._v(" 初始化引导 "),
            ],
            1
          )
        : _vm._e(),
      !_vm.isDemo &&
      _vm.userConfig.packageStyle === "1" &&
      _vm.currentSystem &&
      Number(_vm.currentSystem.subTab) < 6 &&
      _vm.systemCode === "ERP"
        ? _c("version-change")
        : _vm._e(),
      _vm.broadcastMessage
        ? _c(
            "a-button",
            {
              staticClass: "right-content__action right-content__action--btn",
              staticStyle: {
                "background-color": "#1e5af9",
                "border-color": "#1e5af9",
                color: "#fff",
              },
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.openNotification },
            },
            [
              _c(
                "svg",
                {
                  staticStyle: {
                    "enable-background": "new 0 0 50 50",
                    "vertical-align": "middle",
                    "margin-right": "0.5rem",
                  },
                  attrs: {
                    version: "1.1",
                    id: "Layer_1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    width: "9.6px",
                    height: "12px",
                    viewBox: "0 0 24 30",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c(
                    "rect",
                    {
                      attrs: {
                        x: "0",
                        y: "13",
                        width: "4",
                        height: "5",
                        fill: "#fff",
                      },
                    },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "height",
                          attributeType: "XML",
                          values: "5;21;5",
                          begin: "0s",
                          dur: "0.6s",
                          repeatCount: "indefinite",
                        },
                      }),
                      _c("animate", {
                        attrs: {
                          attributeName: "y",
                          attributeType: "XML",
                          values: "13; 5; 13",
                          begin: "0s",
                          dur: "0.6s",
                          repeatCount: "indefinite",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "rect",
                    {
                      attrs: {
                        x: "10",
                        y: "13",
                        width: "4",
                        height: "5",
                        fill: "#fff",
                      },
                    },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "height",
                          attributeType: "XML",
                          values: "5;21;5",
                          begin: "0.15s",
                          dur: "0.6s",
                          repeatCount: "indefinite",
                        },
                      }),
                      _c("animate", {
                        attrs: {
                          attributeName: "y",
                          attributeType: "XML",
                          values: "13; 5; 13",
                          begin: "0.15s",
                          dur: "0.6s",
                          repeatCount: "indefinite",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "rect",
                    {
                      attrs: {
                        x: "20",
                        y: "13",
                        width: "4",
                        height: "5",
                        fill: "#fff",
                      },
                    },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "height",
                          attributeType: "XML",
                          values: "5;21;5",
                          begin: "0.3s",
                          dur: "0.6s",
                          repeatCount: "indefinite",
                        },
                      }),
                      _c("animate", {
                        attrs: {
                          attributeName: "y",
                          attributeType: "XML",
                          values: "13; 5; 13",
                          begin: "0.3s",
                          dur: "0.6s",
                          repeatCount: "indefinite",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" 直播 "),
            ]
          )
        : _vm._e(),
      _c(
        "a-button",
        {
          staticClass: "right-content__action right-content__action--btn",
          staticStyle: {
            "background-color": "#1e5af9",
            "border-color": "#1e5af9",
            color: "#fff",
          },
          attrs: { type: "primary", size: "small" },
          on: { click: _vm.showAIAssistant },
        },
        [_vm._v(" " + _vm._s(_vm.$t("header_ai_assistant")) + " ")]
      ),
      _c(
        "a-button",
        {
          staticClass: "right-content__action right-content__action--btn",
          staticStyle: {
            "background-color": "#28a864",
            "border-color": "#28a864",
            color: "#fff",
          },
          attrs: { type: "primary", size: "small" },
          on: { click: _vm.showNewFunction },
        },
        [_vm._v(" 新功能 ")]
      ),
      _vm.showProdAIImage
        ? _c(
            "a-tooltip",
            { attrs: { title: "亚马逊AI全能助手，用麦多，越卖越多" } },
            [
              _c(
                "a",
                {
                  staticClass: "right-content__action",
                  on: { click: _vm.showProdAIAssistant },
                },
                [
                  _c("img", {
                    staticStyle: { "margin-right": "5px", width: "16.8px" },
                    attrs: {
                      src: require("@/assets/px-logo.png"),
                      alt: "麦多AI",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#fff",
                        "font-size": "16px",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("麦多AI")]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "a-popover",
        {
          attrs: {
            overlayClassName: "export-center-entry-head-drop-overlay",
            placement: "bottomRight",
            visible: _vm.visibleDownlodaCenter,
            trigger: _vm.visibleDownlodaCenter ? "click" : "hover",
          },
        },
        [
          _c(
            "template",
            { slot: "content" },
            [
              _c(
                "p",
                {
                  staticStyle: {
                    width: "200px",
                    height: "70px",
                    "font-weight": "bold",
                    "margin-top": "10px",
                    color: "#fff",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.i18nRender("layouts.exportcenterhere")) +
                      " "
                  ),
                ]
              ),
              _c(
                "a-button",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "10px",
                    bottom: "10px",
                    overflow: "hidden",
                    background: "#1e5af9",
                    color: "#fff",
                  },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleKnow },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("common_btn_i_know")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "a-tooltip",
            { attrs: { title: _vm.i18nRender("layouts.exportcenter") } },
            [
              _c(
                "span",
                {
                  staticClass: "right-content__action",
                  on: { click: _vm.viewExportCenter },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        t: "1723550081342",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "8917",
                        "data-spm-anchor-id":
                          "a313x.manage_type_myprojects.0.i2.32193a81iPrHDr",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64z m19.2 156.032c7.04 0 12.8 5.76 12.8 12.8v379.136h113.92a12.8 12.8 0 0 1 9.408 21.44L521.408 793.6a12.8 12.8 0 0 1-18.88 0l-145.92-160.192a12.8 12.8 0 0 1 9.536-21.44H480V232.832c0-7.04 5.76-12.8 12.8-12.8h38.4z",
                          "p-id": "8918",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        2
      ),
      !_vm.isDemo && _vm.isNote ? _c("NewsList") : _vm._e(),
      _c(
        "a-tooltip",
        { attrs: { title: _vm.i18nRender("layouts.onlineservice") } },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "demo",
                  rawName: "v-demo",
                  value: "getQueryList",
                  expression: "'getQueryList'",
                },
              ],
              staticClass: "right-content__action",
              attrs: { href: "javascript:;" },
            },
            [_c("icon-font", { attrs: { type: "gb-icon-kefu" } })],
            1
          ),
        ]
      ),
      !_vm.isYST_user
        ? _c("ServiceEnter", { attrs: { getQueryList: _vm.getQueryList } })
        : _vm._e(),
      _c("AvatarDropdown"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }